const RULES_OF_THE_GAME = [
  `Find ‘The Poppa Don!’... One of you needs to become head honcho and be responsible for rewarding points. Decide now.`,
  `Don’t resist...go ahead and hit that big button! The Poppadomination machine will throw you the object it wants you to craft your poppadom to.`,
  `Poppadominators ready! You all have a cool 45 seconds to crack ONE poppadom into the shape of that object… sounds simple? Well, if you finish earlier just shout ‘PoppaDONE!’ and you stop the clock for everyone.`,
  `As soon as PoppaDONE! has been declared (or the timer ran down), ‘The Poppa Don’ steps into play. Your leader will judge the poppadoms, point to the owner of the closest resembling poppadom and reward the ‘Poppa-point’.`,
  `Thinking of starting a fight? I’d think again… Arguing with ‘The Poppa Don’ leads to a  Poppabomb. What is a Poppabomb, you say? It’s simple, ‘The Poppa Don’ will poke a hole in one of your poppadoms and you must use that in a future round. So you can wave those poppa-points goodbye!`,
  `SURPRISE. A silver bullet has occurred… yes, that can happen. If the machine produces the silver bullet, you are allowed to Poppabomb one other person's poppadom in that round. Choose wisely.`,
  `Swappadom is not allowed. You must always handle your own.`,
  `At the end, the winner declares Poppadomination! The loser must get out the Moppadom and clear the mess up.`
]

function Rules() {
  return (
    <ul className="list-disc space-y-2">
      {RULES_OF_THE_GAME.map((rule, id) => {
        return (
          <li key={id} className="flex items-start">
            <span className="h-6 flex items-center sm:h-7">
              <svg className="flex-shrink-0 h-5 w-5 text-cyan-500" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
            </span>
            <p className="ml-2">
              {rule}
            </p>
          </li>
        )
      })}
    </ul>
  )
}

function Instructions() {
  return (
    <div className="min-h-screen bg-gray-100 py-6 flex flex-col justify-center sm:py-12">
      <div className="relative py-3 sm:max-w-xl mx-auto">
        <div className="absolute inset-0 bg-gradient-to-r from-poppared to-poppablack shadow-lg transform -skew-y-6 sm:skew-y-0 sm:-rotate-6 rounded-3xl"></div>
          <div className="relative px-4 py-10 bg-white shadow-lg rounded-3xl sm:p-20">
            <div className="max-w-md mx-auto">
              <div>
                <img src="/poppadomination2.png" alt='poppadominaton logo' />
              </div>
              <div className="divide-y divide-gray-200">
                <div className="text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7">
                  <p>Race against friends and family by cracking poppadoms into the shapes of countries, animals, kitchen utensils and more to achieve ultimate ‘Poppadomination’!</p>
                  <p><strong>How it works</strong></p>
                  <Rules />
                  <div className="relative px-4 py-10 sm:rounded-3xl sm:p-20">
                    <a href='/start' className='bg-poppared text-white p-6 rounded-lg'>Let's Poppadominate!</a>
                  </div>
                </div>
                <div className="pt-6 text-base leading-6 font-bold sm:text-lg sm:leading-7">
                  <p><small>&copy; Poppadomination {new Date().getFullYear()}</small></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
}

export default Instructions

